import React, { Component } from 'react';
import styled from 'styled-components';
import { Container } from '../../../components/containers/container';
import Grid from 'styled-components-grid';
import { Padding } from 'styled-components-spacing';
import { Box } from '../../../components/containers/box';
import {
  HeadlineOne,
  HeadlineTwo,
  HeadlineThree,
  Paragraph,
  ParagraphLarge
} from '../../../components/typography';

import LadderStep from './components/ladder.step';
import LadderHeader from './components/ladder.header';
import SideBar from '../../../components/navigation/sidebar';
import { getAffinityLadder } from '../../../data';
import { useQuery } from 'react-apollo-hooks';
import { LOAD_BRAND_AFFINITYLADDER } from '../../../utils/gql';

interface AffinityLadderProps {
  brand: any;
  data: any;
}

export function AffinityLadder(props: AffinityLadderProps) {
  return (
    <Container>
      <SideBar active="strategic" brand={props.brand} />
      <Grid>
        <Grid.Unit size={{ sm: 1 }}>
          <Padding all={2}>
            <HeadlineOne>AFFINITY LADDER</HeadlineOne>
          </Padding>
        </Grid.Unit>
      </Grid>
      <Grid>
        <Grid.Unit size={{ sm: 12 / 12 }}>
          <Padding all={2}>
            <Box>
              <Padding all={2}>
                <Grid>
                  <Grid.Unit size={{ sm: 1, md: 1 }}>
                    <Padding all={2}>
                      <ParagraphLarge>
                        Identifies key points of customer contact and what each
                        means relative to the job they perform in the core
                        consumer’s life.
                      </ParagraphLarge>
                    </Padding>
                  </Grid.Unit>
                </Grid>
                <LadderHeader />
                {props.data.map((step, i) => {
                  return <LadderStep key={i} index={i} {...step} />;
                })}
              </Padding>
            </Box>
          </Padding>
        </Grid.Unit>
      </Grid>
    </Container>
  );
}

export function AffinityLadderScreenLoader(props: any) {
  const { data, error, loading } = useQuery(LOAD_BRAND_AFFINITYLADDER, {
    variables: { id: props.match.params.brand }
  });

  if (loading || !data) return null;
  if (error) return null;

  return (
    <AffinityLadder
      data={data.brand.affinityLadder.contents}
      brand={props.match.params.brand}
    />
  );
}

export default AffinityLadderScreenLoader;
